'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { openResponsiveDialog } from '@/stores/ResponsiveDialogStore';
import { KosafHouseholdConsentContent } from './KosafHouseholdConsentContent';
export interface ShortcutActionRowProps {
  label: string;
  iconSrc: string;
  onNavigate?: () => void;
}
export const KosafHouseholdShortcutRow = t0 => {
  const $ = _c(10);
  const {
    label,
    iconSrc,
    onNavigate
  } = t0;
  let t1;
  if ($[0] !== onNavigate) {
    t1 = () => {
      onNavigate?.();
      openResponsiveDialog({
        component: KosafHouseholdConsentContent,
        modalHeader: "\uAC00\uAD6C\uC6D0 \uB3D9\uC758",
        drawerType: "full"
      });
    };
    $[0] = onNavigate;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleClick = t1;
  let t2;
  if ($[2] !== iconSrc) {
    t2 = <Image src={iconSrc} alt="" width={24} height={24} unoptimized={true} className="size-24 shrink-0" />;
    $[2] = iconSrc;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== label) {
    t3 = <span className="line-clamp-1 font-500 text-Gray-900 typo-body3">{label}</span>;
    $[4] = label;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== handleClick || $[7] !== t2 || $[8] !== t3) {
    t4 = <button type="button" onClick={handleClick} className="flex w-full items-center gap-8 px-20 py-12 text-left transition-colors hover:bg-Gray-50">{t2}{t3}</button>;
    $[6] = handleClick;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};